/**
 * Company API
 * Used for: - Manage Company 
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import Manager from './Manager';


class Company {
    
    constructor(email) { 
        
        Company.initialize(this, email);
    }

    
    static initialize(obj, email) { 
        obj['email'] = email;
    }

    
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new Company();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'String');
            }
            if (data.hasOwnProperty('phone')) {
                obj['phone'] = ApiClient.convertToType(data['phone'], 'String');
            }
            if (data.hasOwnProperty('email')) {
                obj['email'] = ApiClient.convertToType(data['email'], 'String');
            }
            if (data.hasOwnProperty('website')) {
                obj['website'] = ApiClient.convertToType(data['website'], 'String');
            }
            if (data.hasOwnProperty('brand')) {
                obj['brand'] = ApiClient.convertToType(data['brand'], 'String');
            }
            if (data.hasOwnProperty('inn')) {
                obj['inn'] = ApiClient.convertToType(data['inn'], 'String');
            }
            if (data.hasOwnProperty('kpp')) {
                obj['kpp'] = ApiClient.convertToType(data['kpp'], 'String');
            }
            if (data.hasOwnProperty('ogrn')) {
                obj['ogrn'] = ApiClient.convertToType(data['ogrn'], 'String');
            }
            if (data.hasOwnProperty('legalEntity')) {
                obj['legalEntity'] = ApiClient.convertToType(data['legalEntity'], 'String');
            }
            if (data.hasOwnProperty('legalEntityAddress')) {
                obj['legalEntityAddress'] = ApiClient.convertToType(data['legalEntityAddress'], 'String');
            }
            if (data.hasOwnProperty('factAddress')) {
                obj['factAddress'] = ApiClient.convertToType(data['factAddress'], 'String');
            }
            if (data.hasOwnProperty('bankAccountNum')) {
                obj['bankAccountNum'] = ApiClient.convertToType(data['bankAccountNum'], 'String');
            }
            if (data.hasOwnProperty('bankName')) {
                obj['bankName'] = ApiClient.convertToType(data['bankName'], 'String');
            }
            if (data.hasOwnProperty('bankInn')) {
                obj['bankInn'] = ApiClient.convertToType(data['bankInn'], 'String');
            }
            if (data.hasOwnProperty('bankKs')) {
                obj['bankKs'] = ApiClient.convertToType(data['bankKs'], 'String');
            }
            if (data.hasOwnProperty('bankBik')) {
                obj['bankBik'] = ApiClient.convertToType(data['bankBik'], 'String');
            }
            if (data.hasOwnProperty('crmManager')) {
                obj['crmManager'] = Manager.constructFromObject(data['crmManager']);
            }
            if (data.hasOwnProperty('profilePicture')) {
                obj['profilePicture'] = ApiClient.convertToType(data['profilePicture'], 'String');
            }
            if (data.hasOwnProperty('statusRegistration')) {
                obj['statusRegistration'] = ApiClient.convertToType(data['statusRegistration'], 'String');
            }
            if (data.hasOwnProperty('enabled')) {
                obj['enabled'] = ApiClient.convertToType(data['enabled'], 'Boolean');
            }
        }
        return obj;
    }


}


Company.prototype['id'] = undefined;


Company.prototype['phone'] = undefined;


Company.prototype['email'] = undefined;


Company.prototype['website'] = undefined;


Company.prototype['brand'] = undefined;


Company.prototype['inn'] = undefined;


Company.prototype['kpp'] = undefined;


Company.prototype['ogrn'] = undefined;


Company.prototype['legalEntity'] = undefined;


Company.prototype['legalEntityAddress'] = undefined;


Company.prototype['factAddress'] = undefined;


Company.prototype['bankAccountNum'] = undefined;


Company.prototype['bankName'] = undefined;


Company.prototype['bankInn'] = undefined;


Company.prototype['bankKs'] = undefined;


Company.prototype['bankBik'] = undefined;


Company.prototype['crmManager'] = undefined;


Company.prototype['profilePicture'] = undefined;


Company.prototype['statusRegistration'] = undefined;


Company.prototype['enabled'] = undefined;






export default Company;

